export enum AdjustmentNoteStatusEnum {
    OPEN = 'OPEN',
    IN_PROGRESS = 'IN PROGRESS',
    CLOSED = 'CLOSED'
}